/* Product recommendations. The section renders empty on a product page, then
   fetches itself through the recommendations route — that route is the only
   one where Shopify populates `recommendations.products`. */
(function () {
  function init(root) {
    if (root.dataset.recommendationsReady === 'true') return;

    var url = root.dataset.url;
    if (!url) return;

    root.dataset.recommendationsReady = 'true';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-recommendations]');

        // No recommendations for this product: leave the empty shell alone.
        if (!fresh || !fresh.innerHTML.trim()) return;

        root.innerHTML = fresh.innerHTML;

        // Scripts inserted via innerHTML never execute, so the slider the
        // markup depends on has to be re-attached by hand. product-slider.js
        // guards against double-init, so re-running it is safe.
        fresh.querySelectorAll('script[src]').forEach(function (old) {
          var script = document.createElement('script');
          script.src = old.src;
          script.defer = true;
          document.body.appendChild(script);
        });
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-recommendations]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-recommendations]').forEach(init);
  });
})();
